import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('side-panel-field', {
  root: {
    variants: {
      divider: ['auto', 'true', 'false'],
    },
    states: ['padded'],
  },
});
